(function(){
  function run(){ document.querySelectorAll('section.kv-section.fqv:not([data-fqv-done])').forEach(init); }
  run();
  document.addEventListener('shopify:section:load', run);
  function init(root){
  root.setAttribute('data-fqv-done', '');
  var cards = [].slice.call(root.querySelectorAll('.kv-card'));
  var data = cards.map(function(c, i){
    var v = c.querySelector('video');
    return {
      poster: v.getAttribute('poster'),
      sources: [].map.call(v.querySelectorAll('source'), function(s){ return [s.getAttribute('src'), s.getAttribute('type')]; }),
      caption: (c.querySelector('.kv-caption') || {}).textContent || '',
      title: c.getAttribute('data-label') || ('Video ' + (i + 1))
    };
  });
  var esc = function(t){ var d = document.createElement('div'); d.textContent = t; return d.innerHTML; };
  var seen = function(el, f){ var r = el.getBoundingClientRect(), h = window.innerHeight; if (!r.height || document.visibilityState === 'hidden') return false; return (Math.min(r.bottom, h) - Math.max(r.top, 0)) / r.height >= f; };
  var onView = function(fn){ var t; var run = function(){ clearTimeout(t); t = setTimeout(fn, 150); }; window.addEventListener('scroll', run, { passive: true }); document.addEventListener('visibilitychange', run); if (window.IntersectionObserver) new IntersectionObserver(run, { threshold: [0, 0.45, 0.55, 1] }).observe(root); run(); };
  var pad = function(n){ return (n < 9 ? '0' : '') + (n + 1); };
  var clean = function(t){ return t.trim().replace(/^"|"$/g, ''); };
  var ICO_OFF = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="m23 9-6 6M17 9l6 6"/></svg>';
  var ICO_ON = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M19 5a10 10 0 0 1 0 14"/></svg>';
  var desk = window.matchMedia('(min-width: 990px)');
  var muted = true;

  /* ---------- PC: Bühne + Playlist ---------- */
  function buildDesk(){
    if (root.querySelector('.fqv-stage')) return;
    var st = document.createElement('div');
    st.className = 'fqv-stage';
    st.innerHTML =
      '<div class="fqv-main"><video playsinline muted preload="none"></video>' +
      '<span class="fqv-live"><i></i>Echte Kundenaufnahme</span>' +
      '<button class="fqv-snd" type="button" aria-label="Ton an/aus">' + ICO_OFF + '</button>' +
      '<div class="fqv-cap"><span class="fqv-num"></span><p></p></div>' +
      '<span class="fqv-bar"><i></i></span></div>' +
      '<ol class="fqv-list">' + data.map(function(d, i){
        return '<li><button type="button" class="fqv-it" data-i="' + i + '">' +
          '<img src="' + d.poster.replace('width=900', 'width=500') + '" alt="" loading="lazy" width="64" height="86">' +
          '<span class="fqv-it__t"><b>' + pad(i) + '</b><strong>' + esc(d.title) + '</strong><em>' + esc(clean(d.caption)) + '</em></span>' +
          '<span class="fqv-it__bar"><i></i></span></button></li>';
      }).join('') + '</ol>';
    root.querySelector('.kv-track').after(st);
    root.classList.add('fqv-desk');
    var vid = st.querySelector('video'), items = st.querySelectorAll('.fqv-it'),
        bar = st.querySelector('.fqv-bar i'), cur = -1, inView = false;
    function load(i, autoplay){
      cur = i;
      vid.innerHTML = data[i].sources.map(function(s){ return '<source src="' + s[0] + '" type="' + s[1] + '">'; }).join('');
      vid.poster = data[i].poster;
      vid.load();
      st.querySelector('.fqv-num').textContent = pad(i) + ' / ' + pad(data.length - 1) + ' · ' + data[i].title;
      st.querySelector('.fqv-cap p').textContent = clean(data[i].caption);
      items.forEach(function(it, k){ it.classList.toggle('is-on', k === i); it.querySelector('i').style.width = '0'; });
      bar.style.width = '0';
      if (autoplay) vid.play().catch(function(){});
    }
    items.forEach(function(it){ it.addEventListener('click', function(){ load(+it.dataset.i, true); }); });
    vid.addEventListener('timeupdate', function(){
      if (!vid.duration) return;
      var p = (vid.currentTime / vid.duration * 100) + '%';
      bar.style.width = p; items[cur].querySelector('i').style.width = p;
    });
    vid.addEventListener('ended', function(){ load((cur + 1) % data.length, inView); });
    vid.addEventListener('click', function(){ vid.paused ? vid.play() : vid.pause(); });
    vid.addEventListener('play', function(){ st.classList.add('is-playing'); });
    vid.addEventListener('pause', function(){ st.classList.remove('is-playing'); });
    st.querySelector('.fqv-snd').addEventListener('click', function(){
      muted = !muted; vid.muted = muted; this.innerHTML = muted ? ICO_OFF : ICO_ON;
      if (!muted && vid.paused) vid.play().catch(function(){});
    });
    load(0, false);
    onView(function(){
      var now = seen(vid, 0.45);
      if (now === inView) return;
      inView = now;
      if (now) vid.play().catch(function(){}); else vid.pause();
    });
  }

  /* ---------- Handy: Reels-Karussell ---------- */
  function buildMob(){
    var track = root.querySelector('.kv-track');
    if (track.dataset.fqv) return;
    track.dataset.fqv = 1;
    cards.forEach(function(c, i){
      var tag = document.createElement('span');
      tag.className = 'fqv-tag';
      tag.innerHTML = '<b>' + pad(i) + '</b>' + esc(data[i].title);
      c.appendChild(tag);
      var snd = document.createElement('button');
      snd.type = 'button'; snd.className = 'fqv-snd'; snd.setAttribute('aria-label', 'Ton an/aus');
      snd.innerHTML = ICO_OFF;
      c.appendChild(snd);
      var v = c.querySelector('video');
      v.muted = true;
      v.addEventListener('click', function(){ if (!c.classList.contains('fqv-on')) return; if (v.paused) { c.removeAttribute('data-up'); v.play().catch(function(){}); } else { c.setAttribute('data-up', ''); v.pause(); } });
      snd.addEventListener('click', function(e){
        e.stopPropagation();
        muted = !muted;
        cards.forEach(function(k){ k.querySelector('video').muted = muted; k.querySelector('.fqv-snd').innerHTML = muted ? ICO_OFF : ICO_ON; });
      });
      v.addEventListener('timeupdate', function(){
        var d = root.querySelectorAll('.kv-dots span')[i];
        if (d && v.duration) d.style.setProperty('--p', (v.currentTime / v.duration * 100) + '%');
      });
      v.addEventListener('ended', function(){
        var n = cards[i + 1];
        if (n) track.scrollTo({ left: n.offsetLeft - (track.clientWidth - n.offsetWidth) / 2, behavior: 'smooth' });
      });
    });
    var secIn = false, active = -1;
    function pick(){
      var mid = track.getBoundingClientRect().left + track.clientWidth / 2, best = 0, bd = 1e9;
      cards.forEach(function(c, i){ var r = c.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - mid); if (d < bd){ bd = d; best = i; } });
      if (best !== active){
        active = best;
        cards.forEach(function(c, i){
          var v = c.querySelector('video');
          c.classList.toggle('fqv-on', i === best);
          if (i !== best){ c.removeAttribute('data-up'); v.pause(); c.classList.remove('is-playing'); v.controls = false; }
        });
      }
      var v = cards[best].querySelector('video');
      if (secIn){ if (v.paused && !v.ended && !cards[best].hasAttribute('data-up')) { v.muted = muted; v.play().catch(function(){}); } }
      else v.pause();
    }
    var t;
    track.addEventListener('scroll', function(){ clearTimeout(t); t = setTimeout(pick, 120); }, { passive: true });
    onView(function(){ secIn = seen(track, 0.55); pick(); });
  }

  function apply(){ if (desk.matches) buildDesk(); else buildMob(); }
  apply();
  desk.addEventListener ? desk.addEventListener('change', apply) : desk.addListener(apply);
  window.addEventListener('resize', function(){ clearTimeout(apply.t); apply.t = setTimeout(apply, 200); }, { passive: true });
  }
})();
